import { memo } from 'react'
import cx from 'classnames'
import { Icon, Icons } from '../icon'

interface TableSearchProps {
  // TODO: Antonio revisar si se puede quitar el no-unused-vars
  // eslint-disable-next-line no-unused-vars
  onSearch: (term: string) => void
  placeholder?: string
  className?: string
}

const TableSearch = memo(
  ({ onSearch, placeholder = 'Buscar...', className }: TableSearchProps) => {
    return (
      <div className={cx('table-search', className)}>
        <Icon size={14} name={Icons.Magnifying} className="table-search-icon" />
        <input
          className="table-search-input"
          type="text"
          placeholder={placeholder}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
    )
  },
)

TableSearch.displayName = 'TableSearch'
export default TableSearch
